import {CMSContentType} from "../CMSType";
import {BaseListContent, BaseListContentParams} from "./list.abstract.content";
import {ListContentParams, ListContentItem} from "./list.content";
import {DetailsContent, DetailsItemsDTO, DetailsParams} from "./details.content";
import {BaseContentItem, BaseContentItemDTO, BaseContentItemParams, BaseListImage} from "./base.content";
import {List} from "immutable";
import {AContent, AContentDTO} from "../base.content";

export class ImageListItemImage extends BaseListImage {

}

export interface ImageListContentItemDTO extends BaseContentItemDTO {
  details: DetailsItemsDTO[];
}

export interface ImageListContentItemParams extends BaseContentItemParams {
  avatar?: ImageListItemImage;
  details: DetailsParams;
}

export class ImageListContentItem extends BaseContentItem {
  public readonly avatar: ImageListItemImage;
  public readonly details: DetailsContent;

  constructor(data: ImageListContentItemParams) {
    super(data);
    this.details = new DetailsContent(data.details);
  }

  public toJSON(): ImageListContentItemParams {
    const { details, avatar } = this;
    return {
      ...super.toJSON(),
      avatar,
      details: details.toParams()
    };
  }
}


export interface ImageListContentParams extends BaseListContentParams<ImageListContentItem> {

}

export interface ImageListContentDTO extends AContentDTO {
  items: ImageListContentItemDTO[];
}

export class ImageListContent extends BaseListContent<ImageListContentItem> {
  constructor(data: ImageListContentParams) {
    super(CMSContentType.imageList, data);
  }
}



// WEBPACK FOOTER //
// ./src/api/club-cms/content/image-list.content.ts